<template>
  <v-app>
    <v-app-bar
      app
      flat
      color="white"
      class="main-app-bar">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="d-inline-flex d-md-none">
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div>{{ email }}</div>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      :permanent="$vuetify.breakpoint.mdAndUp"
      color="#313a46"
      overlay-color="white">
      <v-toolbar
        flat
        color="#313a46">
        <img
          src="../../assets/logo-dark.png"
          width="32px"
          class="mx-auto">
      </v-toolbar>
      <MenuCtl />
      <v-footer
        absolute
        color="#313a46"
        class="pa-4">
        <v-btn
          color="primary"
          block
          depressed
          @click="signOut">
          로그아웃
        </v-btn>
      </v-footer>
    </v-navigation-drawer>
    <v-main>
      <router-view></router-view>
      <v-footer
        color="white"
        class="text-subtitle-2 font-weight-regular"
        absolute>
        <span>&copy; {{ new Date().getFullYear() }} PICASSOCUBE</span>
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import CONFIG from '@/config';

import MenuCtl from '@/components/controls/MenuCtl'

export default {
  components: {
    MenuCtl
  },

  data: () => ({
    drawer: false
  }),

  computed: {
    user () {
      return this.$store.state.auth.user.user
    },

    email () {
      return this.user.email
    },

    useFirebase () {
      return CONFIG.USE_FIREBASE
    }
  },

  methods: {
    signOut () {
      this.$store.dispatch('auth/signOut', this.$firebase)
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.main-app-bar .v-toolbar__content, .v-toolbar__extension {
  border-bottom: thin solid rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/app/Main.vue